<main class="container">
    <section id="column2">
    </section>
    <section id="column1">
        <div class="loader-container">
            <ng-lottie width="200px" height="200px" [options]="loader"
                style="position: fixed;left: 40%;top:30%;"></ng-lottie>
        </div>
    </section>
</main>